import React from "react";
import {
  Box,
  useColorModeValue,
  Text,
  Progress,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { PracticeQuestionSetAttemptAnalytics } from '../../../Platform/Common/types';

interface QsetAnalyticsProps {
  examAttemptedQsetAnalyticsProp: PracticeQuestionSetAttemptAnalytics;
}

const formatTimeSpent = (seconds: number): string => {
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `${mins}m ${secs}s`;
};

const B2CQuestionSetAnalytics: React.FC<QsetAnalyticsProps> = ({
  examAttemptedQsetAnalyticsProp,
}) => {
  const paneBg = useColorModeValue("gray.50", "gray.700");

  if (
    !examAttemptedQsetAnalyticsProp.analytics_json ||
    Object.keys(examAttemptedQsetAnalyticsProp.analytics_json).length === 0
  ) {
    return (
      <Box p={4} textAlign="center" color="gray.500">
        No analytics available for this question set.
      </Box>
    );
  }

  return (
    <Box bg={paneBg} p={4} 
    borderRadius="md" 
   // shadow="sm"
    >
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        {examAttemptedQsetAnalyticsProp.title} – Analytics
      </Text>

      <VStack align="stretch" spacing={4}>
        {Object.entries(examAttemptedQsetAnalyticsProp.analytics_json)
          .sort(([, a], [, b]) => (b.relative_weight ?? 0) - (a.relative_weight ?? 0))
          .map(([tag, perf]) => {
            const fraction = perf.fraction ?? 0;
            const percentage = Math.round(fraction * 100);

            let colorScheme = "red";
            if (fraction >= 0.9) {
              colorScheme = "green";
            } else if (fraction >= 0.8) {
              colorScheme = "blue";
            } else if (fraction >= 0.5) {
              colorScheme = "orange";
            } else {
              colorScheme = "red";
            }

            return (
              <Box key={tag}>
                <HStack justify="space-between" mb={1}>
                  <Text fontWeight="semibold">
                    {tag}{" "}
                    <Text as="span" color="gray.500" fontWeight="semibold" fontSize="sm">
                      ({perf.relative_weight}% weight)
                    </Text>
                  </Text>
                  <HStack spacing={3}>
                    <Text fontSize="xs" color="gray.500">
                      {formatTimeSpent(perf.time_spent ?? 0)}
                    </Text>
                    <Text fontSize="sm" fontWeight="bold" color="gray.500">
                      {perf.fraction !== null ? `${percentage}%` : "N/A"}
                    </Text>
                  </HStack>
                </HStack>
                <Progress
                  value={perf.fraction !== null ? percentage : 0}
                  size="md"
                  borderRadius="md"
                  colorScheme={colorScheme}
                />
              </Box>
            );
          })}
      </VStack>
    </Box>
  );
};

export default B2CQuestionSetAnalytics;